export default __webpack_public_path__ + "static/pic1-2f4c676995eb9135ab0b1a2736c6c53a.png";